import type {
  AnimalSensitivityEnum,
  AnimalSizeEnum,
  AnimalTypeEnum,
  BirthdayType,
  DogMedicalAffectionType,
  DogPhysicalCondition,
  GenderEnum,
} from '@gql/graphql';
import type { FormMode } from '@presentation/types';
import type { Dayjs } from 'dayjs';
import type { FormikErrors, FormikProps, FormikSharedConfig } from 'formik';
import type { MouseEventHandler, ReactElement, Ref } from 'react';
import type { SelectOption } from '..';

export interface BuyerAnimalFormValues {
  type?: AnimalTypeEnum;
  name?: string;
  birthdayType?: BirthdayType;
  birthday?: Dayjs;
  gender?: GenderEnum;
  sterilized?: boolean;
  size?: AnimalSizeEnum;
  calved?: boolean;
  images?: File[] | string[] | undefined[];
  sensitivities?: AnimalSensitivityEnum[];

  dogInfo?: BuyerAnimalFormValuesDogInfo;
}

export interface BuyerAnimalFormOptions {
  breeds: SelectOption<number>[];
  animalTypes: SelectOption<AnimalTypeEnum>[];
}

export interface BuyerAnimalFormValuesDogInfo {
  physicalCondition?: DogPhysicalCondition;
  medicalAffections?: DogMedicalAffectionType[];
  pedigree?: string | null;
  pedigreeNumber?: string;
  breedId?: number;
}

export interface BuyerAnimalFormData {
  mode: FormMode;
  form: {
    initialValues: BuyerAnimalFormValues;
    onSubmit: (values: BuyerAnimalFormValues) => void;
    validationSchema?: any;
    validate?: any;
    options: BuyerAnimalFormOptions;
  };
  onCancelClick?: MouseEventHandler;
  disabledFields?: Partial<Record<keyof Omit<BuyerAnimalFormValues, 'dogInfo'>, boolean>> & {
    dogInfo: Partial<Record<keyof BuyerAnimalFormValuesDogInfo, boolean>>;
  };
}

export interface BuyerAnimalFormMethods {
  validateForm: () => Promise<FormikErrors<BuyerAnimalFormValues>>;
  getValues: () => BuyerAnimalFormValues;
}

export interface BuyerAnimalFormProps extends BuyerAnimalFormData {
  customSubmitButtons?: (
    formProps: FormikProps<BuyerAnimalFormValues> & FormikSharedConfig<BuyerAnimalFormValues>,
  ) => ReactElement;
  refId?: Ref<HTMLFormElement>;
  imageLabel?: string;
  isBookingForm?: boolean;
}
